import { useState } from "react";

import {
  CrudMode,
  UpdateIconButton,
  formatDecimal,
  formatPercent,
  LockedIcon,
  pn,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@compass/core";

import {
  ListPropertyBase,
  PartnerListDto,
  PartnerListResource,
  Permission,
  PermissionAction,
  SortObject,
} from "generated/openApi";
import { isAuthorized } from "services";
import { useNavigate } from "react-router-dom";
import { partnerPageRoute } from "../PartnerPage/PartnerPage";

import { ListBeProperty } from "components";

export const PartnerTable = (props: {
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  partners: PartnerListDto[];
  resource: PartnerListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
}) => {
  const navigate = useNavigate();
  const properties = props.resource.properties || [];

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell type="id">
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<PartnerListDto>("id"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<PartnerListDto>("name"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell align="right">
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<PartnerListDto>("currentIndirectPercent"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell align="right">
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<PartnerListDto>("currentMileage"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.partners.map((partnerItem) => (
            <TableRow
              key={partnerItem.id}
              onClick={() => navigate(partnerPageRoute.getPath({ id: partnerItem.id, crudMode: "view" }))}
            >
              <TableCell type="id">{partnerItem.id}</TableCell>
              <TableCell>{partnerItem.name}</TableCell>
              <TableCell align="right">{formatPercent(partnerItem.currentIndirectPercent)}</TableCell>
              <TableCell align="right">{formatDecimal(partnerItem.currentMileage, 3)}</TableCell>
              <TableCell type="action">
                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                  <UpdateIconButton
                    onClick={() => navigate(partnerPageRoute.getPath({ id: partnerItem.id, crudMode: "edit" }))}
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
